import React from "react";
import loadingLogo from "../assets/loading.webp";

const Loading: React.FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50">
      <div className="relative flex flex-col items-center">
        
        {/* موج اطراف لوگو */}
        <div className="absolute w-40 h-40 flex items-center justify-center">
          <span className="absolute w-32 h-32 border-4 border-blue-300 rounded-full animate-ping"></span>
          <span className="absolute w-40 h-40 border-4 border-blue-500 rounded-full animate-ping [animation-delay:0.6s]"></span>
        </div>

        {/* لوگو ثابت با افکت */}
        <img
          src={loadingLogo}
          alt="App Logo"
          className="w-32 h-32 object-contain animate-pulse drop-shadow-xl"
        />

        {/* متن لودینگ */}
        <p className="mt-6 text-gray-700 font-medium tracking-wide animate-pulse">
          در حال بارگذاری...
        </p>
      </div>
    </div>
  );
};

export default Loading;
